import BlogsDetail from "../components/layout/home/blogs/BlogsDetail";

const BlogsDetailPage = () => {
  return <BlogsDetail />;
};

export default BlogsDetailPage;
